import { createSelector } from '@reduxjs/toolkit';
import { ContentModel } from '../../models/content.model';
import { GoogleMapsType, Setting, SettingKey } from '../../models/setting.model';

const selectPublicState = (state: any) => state.public;

export const selectAvailability = createSelector(
  [selectPublicState],
  (publicState) => publicState?.availability || []
);

export const selectAvailabilityAndSettings = createSelector(
  [selectPublicState],
  (publicState) => ({
    availability: publicState?.availability || [],
    settings: publicState?.settings || []
  })
);

export const selectLoading = createSelector(
  [selectPublicState],
  (publicState) => publicState?.loading
);

export const selectBooking = createSelector(
  [selectPublicState],
  (publicState) => publicState?.booking
);

export const selectRedirectUrl = createSelector(
  [selectPublicState],
  (publicState) => publicState?.redirectUrl
);

export const selectContent = createSelector(
  [selectPublicState],
  (publicState) => publicState?.content
);

export const selectHeroContent = createSelector(
  [selectContent],
  (content: ContentModel) => ({
    hero: content?.hero,
    buttons: content?.buttons
  })
);

export const selectReservationContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.reservation
);

export const selectFooterContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.footer
);

export const selectMapContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.map
);

export const selectMoreInfoContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.moreInfo
);

export const selectPricingContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.pricing
);

export const selectLandingPageContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.main
);

export const selectSuccessContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.success
);

export const selectErrorContent = createSelector(
  [selectContent],
  (content: ContentModel) => content?.error
);

export const selectTheaterMapData = createSelector(
  [selectPublicState],
  (publicState) => ({
    googleMapsType: publicState?.settings?.find((setting: Setting) => setting.setting_key === SettingKey.GOOGLE_MAPS_TYPE)?.setting_value as GoogleMapsType || GoogleMapsType.IFRAME,
    mapContent: publicState?.content?.map,
  }));

export const selectBookingCreateLoading = createSelector(
  [selectPublicState],
  (publicState) => publicState?.bookingCreateLoading
);